import { api } from "./index.ts";

export interface Project {
    id: string;
    title: string;
    description: string;
    category_id: string;
    images: string[];
    videos?: string[];
    price: number;
    similar_ids: string[];
    completed_at?: string | null;
    created_at?: string;
    updated_at?: string;
}

export async function getProjects(): Promise<Project[]> {
    try {
        const response = await api.get("/projects");
        return response.data.projects || response.data || [];
    } catch (err) {
        return [];
    }
}

export async function getProject(id: string): Promise<Project | null> {
    try {
        const response = await api.get(`/projects/${id}`);
        return response.data.project || response.data || null;
    } catch (err) {
        return null;
    }
}

export async function getCategories() {
    try {
        const response = await api.get("/categories");
        return response.data.categories || response.data || [];
    } catch (err) {
        return [];
    }
}

export async function addProject(payload: {
    title: string;
    description: string;
    category_id: string;
    images: string[];
    videos?: string[];
    price: number;
    similar_ids: string[];
    completed_at?: string | null;
}): Promise<Project> {
    try {
        const requestData: any = {
            title: payload.title,
            description: payload.description,
            category_id: payload.category_id,
            images: Array.isArray(payload.images) ? payload.images : [],
            videos: Array.isArray(payload.videos) ? payload.videos : [],
            price: payload.price,
            similar_ids: Array.isArray(payload.similar_ids) ? payload.similar_ids : [],
            completed_at: payload.completed_at ?? null
        };

        const response = await api.post("/projects", { project: requestData });
        return response.data.project || response.data;
    } catch (err: any) {
        console.error("Ошибка при добавлении проекта:", err);
        if (err.response) console.error("Детали ошибки:", err.response.data);
        throw err;
    }
}

export async function updateProject(id: string, payload: {
    title: string;
    description: string;
    category_id: string;
    images: string[];
    videos?: string[];
    price: number;
    similar_ids: string[];
    completed_at?: string | null;
}): Promise<Project> {
    try {
        const requestData: any = {
            title: payload.title,
            description: payload.description,
            category_id: payload.category_id,
            images: Array.isArray(payload.images) ? payload.images : [],
            videos: Array.isArray(payload.videos) ? payload.videos : [],
            price: payload.price,
            similar_ids: Array.isArray(payload.similar_ids) ? payload.similar_ids : [],
            completed_at: payload.completed_at ?? null
        };

        const putResp = await api.put(`/projects/${id}`, { project: requestData });
        console.log("Sending update payload:", { project: requestData });
        console.log("PUT response:", putResp.data);

        if (putResp.data && (putResp.data.project || putResp.data.id)) {
            return putResp.data.project || putResp.data;
        }

        const fresh = await getProject(id);
        if (fresh) return fresh;

        const all = await getProjects();
        const found = (all || []).find((p: any) => p && p.id === id);
        if (found) return found;

        return putResp.data;
    } catch (err: any) {
        if (err.response) console.error("Детали ошибки:", err.response.data);
        throw err;
    }
}

export async function deleteProject(id: string): Promise<boolean> {
    try {
        await api.delete(`/projects/${id}`);
        return true;
    } catch (err) {
        throw err;
    }
}
